export enum DataTypeEnum {
    SearchClients = "SearchClients",
    ConditionFormFieldKey = "ConditionFormFieldKey",
    FileUploadType = "FileUploadType",
    SubSection = "SubSection",
    FormFieldKeyDependency = "FormFieldKeyDependency",
    FormFieldKey = "FormFieldKey",
    Centres = "Centres",
    NewsCategorys = "NewsCategorys",
    CentreContactTypes = "CentreContactTypes",
    ClientNames = "ClientNames",
    Counties = "Counties",
    Users = "Users",
    Genders = "Genders",
    EyeColours = "EyeColours",
    HairColours = "HairColours",
    EthnicOrigins = "EthnicOrigins",
    CareStatuses = "CareStatuses",
    BodyTypes = "BodyTypes",
    LHOAreas = "LHOAreas",
    Complexions = "Complexions",
    ClientContactTypes = "ClientContactTypes",
    CentreByUser = "CentreByUser",
    FormFieldKeySpecialType = "FormFieldKeySpecialType",
    FormTemplate = "FormTemplates",
    FormStatus = "FormStatuses",
    Days = "Days",
    FormTemplateType = "FormTemplateTypes",
    YesNo = "YesNo"

}
